export const tokenPrefix = 'seam_';
export const accessTokenPrefix = 'seam_at';
export const jwtPrefix = 'ey';
export const clientSessionTokenPrefix = 'seam_cst';
export const publishableKeyTokenPrefix = 'seam_pk';
export const isAccessToken = (token) => token.startsWith(accessTokenPrefix);
export const isJwt = (token) => token.startsWith(jwtPrefix);
export const isSeamToken = (token) => token.startsWith(tokenPrefix);
export const isApiKey = (token) => !isClientSessionToken(token) &&
    !isJwt(token) &&
    !isAccessToken(token) &&
    !isPublishableKey(token) &&
    isSeamToken(token);
export const isClientSessionToken = (token) => token.startsWith(clientSessionTokenPrefix);
export const isPublishableKey = (token) => token.startsWith(publishableKeyTokenPrefix);
export const isConsoleSessionToken = (token) => isJwt(token);
export const isPersonalAccessToken = (token) => isAccessToken(token);
//# sourceMappingURL=token.js.map